import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSoftwareDevelopmentIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_5777",
		"data-name": "Group 5777",
		transform: "translate(-1702 -436)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_8175",
			"data-name": "Path 8175",
			d: "M4,7A1,1,0,0,1,5,6H21a1,1,0,0,0,0-2H4A2.006,2.006,0,0,0,2,6V17H1.5a1.5,1.5,0,0,0,0,3H14V17H4ZM23,8H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V9A1,1,0,0,0,23,8Zm-1,9H18V10h4Z",
			transform: "translate(1702 432)"
		})
	})
});
export { SvgSoftwareDevelopmentIcon as ReactComponent };
